export default {
  "en": {
    "backTitle": "Back",
    "title": "Privacy Policy",
    "contents": {
      "title": "Privacy Policy",
      "text": "",
      "step": [
        {
          "title": "Welcome to the LinknLink Smart Home Service Platform!",
          "tip": ""
        },
        {
          "title": "Updated: August 10, 2026   Effective Date: August 10, 2026",
          "tip": ""
        },
        {
          "title": "LinknLink PTY LTD and its affiliates (hereinafter referred to as \"we\" or \"LinknLink\") are committed to protecting your personal privacy. This privacy policy (hereinafter referred to as \"this Policy\") explains how we handle personal data and protect information privacy when you use the following services, products, and related mobile applications (collectively referred to as \"Products\").",
          "tip": ""
        },
        {
          "title": "Before using our Products, please read and understand this Policy. We obtain consent through the privacy-consent dialog or another method required by applicable law. Sensitive personal data, system permissions, third-party account linking, and transmission of personal data to LinknLink AI servers are separately explained in context and are subject to separate permission before transmission. General acceptance of this Policy does not constitute permission to transmit AI-related data. You may refuse non-essential processing; refusal affects only the corresponding feature, not unrelated services.",
          "tip": ""
        },
        {
          "title": "1. Term Definitions",
          "tip": ""
        },
        {
          "title": "1.1 In this Policy, \"Personal Data\" means personally identifiable information that can be used alone or in combination with other information to identify an individual. \"Smart Devices\" refer to non-standard computing devices produced or manufactured by hardware manufacturers that have a human-machine interface and can transmit data through wireless networks, including smart home appliances, smart wearable devices, smart air purifiers, etc. \"Applications\" refer to mobile applications developed by LinknLink that allow end users to remotely control smart devices and connect to LinknLink's Internet of Things (IoT) platform.",
          "tip": ""
        },
        {
          "title": "1.2 For other brands' mobile applications supported by LinknLink, it is our customers who decide what personal data to collect through our Products. We collect information according to customer requirements, and the handling of this information is limited to providing the services agreed upon with our customers.",
          "tip": ""
        },
        {
          "title": "1.3 To provide you with our services, we will ask you to provide the personal data required for such services. If you do not provide personal data, we may not be able to provide you with our Products or services.",
          "tip": ""
        },
        {
          "title": "2. Information You Actively Provide",
          "tip": ""
        },
        {
          "title": "2.1 Account or Profile Data: When you register an account with us, we may collect your name and contact information, such as your email address, phone number, username, and login credentials. During your interaction with our Products, we may further collect your nickname, avatar, country code, language preferences, or timezone information in your account, etc.",
          "tip": ""
        },
        {
          "title": "2.2 Feedback: When you use the feedback and suggestion feature in our Products, we will collect your voluntarily provided email address, phone number, and feedback content in order to promptly handle your issues and device failures.",
          "tip": ""
        },
        {
          "title": "2.3 Device Information: When you add smart devices to your account, we may collect relevant information about the devices, including device name, device model, device ID, firmware version, etc.",
          "tip": ""
        },
        {
          "title": "3. Information We Automatically Collect",
          "tip": ""
        },
        {
          "title": "3.1 Account Information: Your user nickname, avatar, phone number, email address, as well as Apple ID authorized login account name, Google authorized login account name, etc.",
          "tip": ""
        },
        {
          "title": "3.2 Device Information: When you interact with our Products, we will automatically collect device information, such as location permission: When the device is connected to the network, Android 6.0 or above needs to obtain device Wi-Fi information (including nearby Wi-Fi list), MAC address, IP address, wireless connection information, operating system type and version, application version number, push notification identifier, log files, and mobile network information.",
          "tip": ""
        },
        {
          "title": "3.3 Usage Data: During your interaction with our websites and services, we automatically collect usage data related to access, clicks, downloads, sending/receiving messages, and other uses of our websites and services.",
          "tip": ""
        },
        {
          "title": "3.4 Log Information: When you use our applications, system and exception logs may be uploaded.",
          "tip": ""
        },
        {
          "title": "3.5 Location Information: When you use some of our products or services, we may collect real-time precise or imprecise geographic location information about you, such as weather services.",
          "tip": ""
        },
        {
          "title": "3.6 Home name, home area (manually set by you), room information, home background image, local electricity price.",
          "tip": ""
        },
        {
          "title": "3.7 Data usually generated when users use functions: scene information, linkage information, remote control panel information.",
          "tip": ""
        },
        {
          "title": "3.8 Smart Device-Related Information:",
          "tip": ""
        },
        {
          "title": "3.8.1 Basic Information of Smart Devices: When you use smart devices connected to our Products or services, we may collect basic information about the smart devices, such as device name, device ID, online status, activation time, firmware version, and upgrade information, etc.",
          "tip": ""
        },
        {
          "title": "3.8.2 Information Reported by Smart Devices: Depending on the different smart devices you choose to connect to our Products or services, we may collect the information your smart devices report. For example, smart sensors may report temperature and humidity, human induction, lighting, etc.",
          "tip": ""
        },
        {
          "title": "3.8.3 Media and File Information: After you authorize camera, photo-library, or file access, we process the images, videos, audio, or files you actively capture, select, crop, save, or share, together with metadata such as file name, size, and format, for avatars, home backgrounds, invitation QR codes, firmware selection, camera preview/snapshots, and receipt OCR. OCR is primarily performed on-device through Google ML Kit; if a page requires an upload, we will provide a specific notice and obtain the necessary authorization.",
          "tip": ""
        },
        {
          "title": "3.9 AI Assistant and Voice Data: When you actively use the AI assistant, speech recognition, voice control, or text-to-speech, we collect and process, through content you type, speak, select, actively attach, or authorize the App to access, your text input, speech transcripts, conversation context, instructions, images or files you actively attach, and execution results. Depending on your request, this may also include the home name, rooms, device names/identifiers/status, scenes and automations, calendar events, reminders, and contact names/details necessary to fulfil the request and authorized by you. The microphone is used only after you enable a voice feature and grant system permission. This necessary data is sent to LinknLink AI servers operated by LinknLink PTY LTD to understand your request, generate a response, plan and perform the smart-home or personal-assistant action you request, prevent abuse, and protect service security.",
          "tip": ""
        },
        {
          "title": "3.9.1 Permission for AI Data Transmission: Before the App first sends the above data to LinknLink AI servers, it will present a separate notice that clearly identifies the data categories, the recipient LinknLink PTY LTD, and the purposes, and will transmit data only after you actively grant permission. General acceptance of this Policy or the Terms of Use does not replace this separate permission. You may refuse or withdraw permission. After refusal or withdrawal, the App will not send new AI-request data to LinknLink AI servers; only features requiring cloud AI processing will be unavailable, while unrelated features remain available.",
          "tip": ""
        },
        {
          "title": "3.9.2 LinknLink AI servers are operated by LinknLink PTY LTD. The App does not send the above AI-request data directly to a third-party AI service provider. If we need to share data with a third-party AI service provider in the future, we will first separately identify the third party, data categories, purposes, and safeguards, verify that the provider offers the same or a higher level of privacy protection, and obtain your renewed express permission before transmission.",
          "tip": ""
        },
        {
          "title": "3.10 Calendar, Reminders, Contacts, SMS, and Call Logs: We access or modify only the fields needed when you specifically ask the AI assistant to query, create, update, or delete calendar events/reminders, or to find a contact and initiate a call, text message, or email, and only after separate authorization. The Android version also declares SMS and call-log permissions; these are accessed only if the corresponding feature is enabled, you initiate the action, and you grant permission. Refusal does not affect unrelated smart-home features.",
          "tip": ""
        },
        {
          "title": "3.11 Health Data (Sensitive Personal Data): Only when you actively use a health-summary feature and separately authorize it, we use Apple Health or Android Health Connect to read the categories you select, including steps, heart rate/resting heart rate, active calories, distance, sleep, weight, oxygen saturation, exercise records, and related timestamps. We do not write to or modify health records, do not use health data for advertising, and process it only to fulfil your request.",
          "tip": ""
        },
        {
          "title": "3.12 Camera, Photos, and Scanning: Camera access is used to scan device QR codes, capture receipts, or provide a photo source. Photo-library access is used to select OCR images, avatars/backgrounds, and to save invitation QR codes or snapshots. If denied, features that do not depend on camera or photos remain available.",
          "tip": ""
        },
        {
          "title": "3.13 Bluetooth, Nearby Devices, Wi-Fi, and Local Network: For device provisioning, discovery, and control, we may, with permission, scan for and connect to Bluetooth devices; read the current Wi-Fi name, network connection details, nearby Wi-Fi or nearby-device information; and use mDNS, Bonjour, multicast, UDP, or CoAP on the local network. Older Android versions may classify Wi-Fi/Bluetooth scanning as location access; we do not use this for continuous location tracking.",
          "tip": ""
        },
        {
          "title": "3.14 Location and Maps: When you request current location, nearby places, weather, sunrise/sunset, navigation, or a map feature, we process precise or approximate location and geocoding results with permission, and may provide coordinates or search terms needed to Apple Maps, Google Maps, or the applicable geocoding service. We do not continuously track background location unless separately disclosed.",
          "tip": ""
        },
        {
          "title": "3.15 Notifications and Background Capabilities: With permission, we process push tokens, notification content, and delivery/open status for device alerts, automations, calendar reminders, AI-assistant notices, and service messages. Background audio, foreground services, boot completion, wake locks, and battery-optimization exemptions are used only for radio/audio playback, device synchronization, notifications, or local services you enable and can be disabled in system settings.",
          "tip": ""
        },
        {
          "title": "3.16 Device and App Identifiers: For account security, device binding, push delivery, compatibility, analytics, and troubleshooting, we may process app instance IDs, internally generated device IDs, model, OS and app versions, language/time zone, IP address, network type, Firebase Installation ID, push token, advertising identifier (if provided by the system), and crash logs. Advertising identifiers are used for app analytics and troubleshooting, not personalized advertising. If related processing legally constitutes cross-app tracking, we obtain authorization before processing as required by the operating system and applicable law.",
          "tip": ""
        },
        {
          "title": "3.17 Shared Content and App Visibility: If you actively share text, images, or files to the App through the operating system, we receive and process them locally as instructed. To open a third-party app or app store you select, the App may query a limited set of capable apps or URL schemes; it does not request access to a complete installed-app inventory.",
          "tip": ""
        },
        {
          "title": "3.18 Infrared, NFC, and Vibration: On compatible devices, infrared access supports remote-control functions, NFC supports proximity pairing or tags you actively tap, and vibration provides operation or notification feedback. These capabilities are called only when you use the relevant feature.",
          "tip": ""
        },
        {
          "title": "4. Use of Personal Information",
          "tip": ""
        },
        {
          "title": "4.1 We use the collected personal data for the following purposes:",
          "tip": ""
        },
        {
          "title": "4.1.1 Provide, process, maintain, improve, and develop our Products and/or services provided to you, including customer support, and other services provided through devices or applications.",
          "tip": ""
        },
        {
          "title": "4.1.2 Communicate with you about the Products and/or services you use, and respond to and provide feedback on issues related to our Products and/or services.",
          "tip": ""
        },
        {
          "title": "4.1.3 Analyze and develop statistics related to the use of our Products and services to better improve our Products and services.",
          "tip": ""
        },
        {
          "title": "4.1.4 Store and maintain your information for our business operations or to fulfill legal obligations.",
          "tip": ""
        },
        {
          "title": "4.1.5 Provide personalized user experience and personalized content, as well as product and service recommendations.",
          "tip": ""
        },
        {
          "title": "4.1.6 Use LinknLink AI servers to understand requests you actively submit, generate responses, plan and perform requested smart-home or personal-assistant actions, and conduct necessary security protection and diagnostics. AI-request data is not used for third-party advertising or cross-app tracking.",
          "tip": ""
        },
        {
          "title": "4.2 Except for health data expressly described in this Policy and processed with separate authorization, we do not actively collect sensitive information about race or ethnicity, political opinions, religious or philosophical beliefs, trade-union membership, genetics, biometrics, sex life, or sexual orientation. We process sensitive personal data only where necessary for a specific feature and apply enhanced safeguards.",
          "tip": ""
        },
        {
          "title": "5. Third-Party SDK Access Explanation",
          "tip": ""
        },
        {
          "title": "5.1 To provide you with better services, our application integrates the following third-party SDKs:",
          "tip": ""
        },
        {
          "title": "5.1.1 Third-party Account Login and Core Functionality SDKs:",
          "tip": ""
        },
        {
          "title": "①WeChat: Third-party entity is Tencent Technology (Shenzhen) Co., Ltd., collected information includes device info, MAC address, IP address, purpose is to help users log in via WeChat, third-party privacy policy: https://weixin.qq.com/cgi-bin/readtemplate?lang=zh_CN&t=weixin_agreement&s=privacy",
          "tip": ""
        },
        {
          "title": "②Apple: Third-party entity is Apple Inc., collected information includes device info, MAC address, IP address, purpose is to help users log in via Apple ID, third-party privacy policy: https://www.apple.com/privacy/",
          "tip": ""
        },
        {
          "title": "③Google: Third-party entity is Google LLC, collected information includes device info, MAC address, IP address, purpose is to help users log in via Google account, third-party privacy policy: https://policies.google.com/privacy",
          "tip": ""
        },
        {
          "title": "④Firebase Analytics, Crashlytics, and Cloud Messaging: Provided by Google LLC; may process app instance/installation identifiers, advertising identifier if available, device and app information, usage events, IP address, crash stacks, and push tokens for analytics, crash diagnostics, and push delivery. Privacy policy: https://policies.google.com/privacy",
          "tip": ""
        },
        {
          "title": "⑤Google Maps SDK: Provided by Google LLC; when you use maps, location, or navigation features it processes coordinates, map queries, and device/network information. Privacy policy: https://policies.google.com/privacy",
          "tip": ""
        },
        {
          "title": "⑥Google ML Kit Text Recognition: Provided by Google LLC; used primarily on-device to recognize text in receipt/images you select or capture and may process image content and necessary device information. Privacy policy: https://policies.google.com/privacy",
          "tip": ""
        },
        {
          "title": "⑦Google Sign-In and Google APIs: Provided by Google LLC; when you choose Google sign-in or authorize services such as Google Tasks, they process OAuth tokens, basic Google-account information, and task data within the scopes you authorize. Privacy policy: https://policies.google.com/privacy",
          "tip": ""
        },
        {
          "title": "⑧Apple Maps, Apple Health, Sign in with Apple, and system services: Provided by Apple Inc.; only when you use and authorize the relevant feature, the operating system processes Apple account, map request, health, calendar, reminder, or contact data. Privacy policy: https://www.apple.com/privacy/",
          "tip": ""
        },
        {
          "title": "⑨LinknLink device SDK, ESP provisioning SDK, and GoHap/Combined Mobile components: Provided by LinknLink or its technical partners for accounts, device discovery, Bluetooth/Wi-Fi provisioning, local-network communications, control, firmware upgrades, HomeKit bridging, and local connectivity. They may process account identifiers, device IDs/status, Wi-Fi/Bluetooth/local-network information, control commands, and diagnostic logs.",
          "tip": ""
        },
        {
          "title": "5.1.2 Smart Device Brand SDK/API Integration:",
          "tip": ""
        },
        {
          "title": "To enable connection and control of various smart device brands, we have integrated services (including OAuth, Cloud APIs, MQTT etc.) for:",
          "tip": ""
        },
        {
          "title": "①Tuya Smart: For connecting and controlling Tuya ecosystem devices.",
          "tip": ""
        },
        {
          "title": "②Xiaomi Mi Home: For connecting and controlling Xiaomi/Mi Home brand devices.",
          "tip": ""
        },
        {
          "title": "③Ezviz: For video stream preview and device control of Hikvision/Ezviz cameras.",
          "tip": ""
        },
        {
          "title": "④WiZ: For local discovery and control of WiZ brand lighting devices.",
          "tip": ""
        },
        {
          "title": "⑤Govee: For controlling Govee smart lights via cloud API or local network.",
          "tip": ""
        },
        {
          "title": "⑥TP-Link (Tapo/Kasa): For connecting and controlling TP-Link smart plugs, bulbs, etc.",
          "tip": ""
        },
        {
          "title": "⑦Netatmo: For connecting and controlling Netatmo weather stations, thermostats, etc.",
          "tip": ""
        },
        {
          "title": "⑧HomeKit: For home automation and local device control within the Apple ecosystem.",
          "tip": ""
        },
        {
          "title": "⑨Google Translate: For in-app translation, speech synthesis, and automatic device-name translation.",
          "tip": ""
        },
        {
          "title": "⑩Samsung SmartThings, Amazon Alexa, and Google Home: Only when you bind them, OAuth/App Flip and related APIs process authorization tokens, home/room/device lists, device status, and control commands for account linking and smart-home/voice control.",
          "tip": ""
        },
        {
          "title": "⑪Philips Hue, Dyson, Shelly, Sonoff/eWeLink, Tado, IKEA Tradfri, Nuki, and other services you add: Their cloud APIs, OAuth, MQTT, or local-network protocols process account tokens, device information, status, and commands within your authorization. Each operator independently processes data under the notice and privacy policy presented during linking.",
          "tip": ""
        },
        {
          "title": "5.2 These components are not all enabled at the same time. We invoke an SDK/API according to operating system, region, device type, and the features you actually use. A third party's own privacy policy governs its processing, server locations, and retention. You can stop future processing by not using or unlinking the feature, withdrawing system permission, or contacting us.",
          "tip": ""
        },
        {
          "title": "5.3 LinknLink AI servers are operated by LinknLink PTY LTD and are not a third-party SDK or third-party AI service. Sections 3.9 through 3.9.2 describe the collection method, data categories, purposes, pre-transmission permission, and withdrawal controls for AI data. If we engage a service provider to process AI data on our behalf, we contractually require it to process data only on our instructions and provide privacy and security protection equal to or greater than this Policy.",
          "tip": ""
        },
        {
          "title": "6. Information Sharing, Disclosure, and Storage",
          "tip": ""
        },
        {
          "title": "6.1 Sharing: We will not sell, trade, or transfer your personal data to third parties. We may share your personal data in the following circumstances:",
          "tip": ""
        },
        {
          "title": "6.1.1 Share after obtaining your explicit consent.",
          "tip": ""
        },
        {
          "title": "6.1.2 To the extent permitted by law, we may share your personal data with our affiliates (including communications, social media, technology, and cloud businesses).",
          "tip": ""
        },
        {
          "title": "6.1.3 Share with authorized partners: We may share your information with our authorized partners to provide the products or services you request, but only to the extent necessary to achieve that purpose.",
          "tip": ""
        },
        {
          "title": "6.2 Disclosure: We may disclose your personal data in the following circumstances:",
          "tip": ""
        },
        {
          "title": "6.2.1 According to applicable laws, regulations, legal procedures, litigation, and/or requirements of public agencies and government departments.",
          "tip": ""
        },
        {
          "title": "6.2.2 If we determine that disclosure is reasonably necessary to enforce our terms and conditions or protect our operations, users, or others.",
          "tip": ""
        },
        {
          "title": "6.3 Storage and International Transfers: Based on your selected country/region and service availability, we use servers in regions including China, Europe (including Germany), and the United States. Cross-border transfers occur only where necessary for accounts, device cloud services, third-party brand linking, AI/translation, push, maps, or diagnostics and where a consent, contract, or other lawful basis required by applicable law is in place. We use safeguards such as encryption, access controls, and contractual protections.",
          "tip": ""
        },
        {
          "title": "6.4 AI Data Transmission: After you separately grant permission and actively submit an AI request, the necessary data listed in Section 3.9 is transmitted over an encrypted connection to LinknLink AI servers. The recipient and data controller is LinknLink PTY LTD. Except for a future situation described in Section 3.9.2 for which renewed express permission is obtained, we do not share AI-request data with a third-party AI service provider.",
          "tip": ""
        },
        {
          "title": "7. Your Rights",
          "tip": ""
        },
        {
          "title": "7.1 According to applicable laws, you may have the right to:",
          "tip": ""
        },
        {
          "title": "7.1.1 Access: You have the right to access personal data we hold about you.",
          "tip": ""
        },
        {
          "title": "7.1.2 Correction: You have the right to correct inaccurate personal data and update your information.",
          "tip": ""
        },
        {
          "title": "7.1.3 Deletion: Under certain circumstances, you have the right to request deletion of your personal data.",
          "tip": ""
        },
        {
          "title": "7.1.4 Withdraw Consent: You have the right to withdraw previously given consent.",
          "tip": ""
        },
        {
          "title": "7.1.5 Object to Processing: You have the right to object to our processing of your personal data.",
          "tip": ""
        },
        {
          "title": "7.1.6 Data Portability: Under certain circumstances, you have the right to receive your personal data in a structured, commonly used, and machine-readable format.",
          "tip": ""
        },
        {
          "title": "7.2 You can access, correct, or delete your personal information at any time through the settings in the application, or contact us through the contact methods we provide to exercise your rights.",
          "tip": ""
        },
        {
          "title": "7.3 Account Deletion: You can request deletion through account settings. We will delete or anonymize your personal information and unlink devices/third-party services, except where retention is required by law or a third party independently retains information under applicable law.",
          "tip": ""
        },
        {
          "title": "7.4 Permission and Authorization Controls: You can disable camera, photos, microphone, speech recognition, Bluetooth, nearby devices, location, notifications, calendar, reminders, contacts, or health permissions in system settings, and unlink Google, SmartThings, Alexa, and other brand accounts in the App. Withdrawal does not affect processing lawfully performed before withdrawal.",
          "tip": ""
        },
        {
          "title": "7.5 AI Permission Controls: You can withdraw permission to transmit data to LinknLink AI servers in the App's AI settings or by contacting us. After withdrawal, we stop sending new AI-request data. You may also delete AI conversation records or exercise the access, correction, and deletion rights described in Section 7.1.",
          "tip": ""
        },
        {
          "title": "8. Data Security",
          "tip": ""
        },
        {
          "title": "8.1 We take industry-standard security measures to protect your personal data, including technical measures, physical measures, and administrative measures, to prevent loss, misuse, unauthorized access, disclosure, alteration, or destruction of personal data.",
          "tip": ""
        },
        {
          "title": "8.2 We use encryption technology (such as SSL) to protect data security during transmission.",
          "tip": ""
        },
        {
          "title": "8.3 We restrict employees, contractors, and agents who access personal data and require them to comply with confidentiality obligations.",
          "tip": ""
        },
        {
          "title": "8.4 Although we have taken reasonable security measures, please note that data transmission or storage on the Internet cannot be guaranteed to be 100% secure.",
          "tip": ""
        },
        {
          "title": "9. Data Retention",
          "tip": ""
        },
        {
          "title": "9.1 We retain personal data only for the shortest period necessary for the purposes described in this Policy. Account and cloud-device data is generally retained until you delete it or close the account. In-App AI conversation records are deleted or anonymized when you delete the relevant records or close your account. Requests and responses sent to LinknLink AI servers are retained only as long as necessary to provide the AI service, protect security, diagnose faults, and comply with legal obligations, and are then deleted or anonymized. Local caches, OCR results, and selected files are removed when you clear App data, delete the records, or uninstall the App. Third-party retention is governed by the third party's privacy policy.",
          "tip": ""
        },
        {
          "title": "9.2 When our Products or services cease operations, we will notify you in a reasonable form and delete or anonymize your personal information within a reasonable period.",
          "tip": ""
        },
        {
          "title": "9.3 Except as otherwise provided by laws and regulations or as otherwise agreed between you and us.",
          "tip": ""
        },
        {
          "title": "10. Children's Privacy",
          "tip": ""
        },
        {
          "title": "10.1 Our Products and services are mainly for adults. Without guardian's permission, we will not collect personal data from children under 16 years old.",
          "tip": ""
        },
        {
          "title": "10.2 If we find that we have collected personal data from children without prior guardian's permission, we will try to delete the relevant data as soon as possible.",
          "tip": ""
        },
        {
          "title": "10.3 If you are a parent or guardian of a child, please contact us through the contact methods in this Policy if you have questions about the processing of your child's personal data.",
          "tip": ""
        },
        {
          "title": "11. Third-Party Services",
          "tip": ""
        },
        {
          "title": "11.1 Our Products may contain links to third-party websites, products, and services.",
          "tip": ""
        },
        {
          "title": "11.2 We are not responsible for the privacy practices of third-party-operated websites, products, or services, and this Policy does not apply to such third-party websites, products, or services.",
          "tip": ""
        },
        {
          "title": "11.3 We recommend that you carefully read the privacy policies of third parties to understand how they handle your personal information.",
          "tip": ""
        },
        {
          "title": "12. Updates to This Policy",
          "tip": ""
        },
        {
          "title": "12.1 We may update this Policy from time to time. When we make material changes to this Policy, we will post a new privacy policy on our website and send you notifications through in-app notifications or other means.",
          "tip": ""
        },
        {
          "title": "12.2 If a change materially affects processing purposes, methods, data categories, recipients, or your rights, we provide a prominent notice and obtain renewed consent where required by applicable law.",
          "tip": ""
        },
        {
          "title": "13. Contact Us",
          "tip": ""
        },
        {
          "title": "13.1 If you have any questions, comments, or suggestions about this Policy, or wish to exercise your rights, you can contact us in the following ways:",
          "tip": ""
        },
        {
          "title": "Company Name: LinknLink PTY LTD",
          "tip": ""
        },
        {
          "title": "Mailing Address: 7 FairyLand Ave, Chatswood West, NSW2067, Australia",
          "tip": ""
        },
        {
          "title": "Email: dpo@linklink-iot.com",
          "tip": ""
        },
        {
          "title": "13.2 We will reply as soon as possible after receiving your contact information.",
          "tip": ""
        }
      ]
    }
  },
  "zh-cn": {
    "backTitle": "返回",
    "title": "隐私条款",
    "contents": {
      "title": "隐私条款",
      "text": "",
      "step": [
        {
          "title": "欢迎使用LinknLink智能家居服务平台！",
          "tip": ""
        },
        {
          "title": "更新时间：2026年8月10日  生效日期：2026年8月10日",
          "tip": ""
        },
        {
          "title": "LinknLink PTY LTD及其关联公司（以下简称\"我们\"或\"LinknLink\"）致力于保护您的个人隐私。本隐私政策（以下简称\"本政策\"）说明了当您使用以下服务、产品和相关移动应用程序（统称为\"产品\"）时，我们如何处理个人数据并保护信息隐私。",
          "tip": ""
        },
        {
          "title": "在使用我们的产品之前，请您仔细阅读并充分理解本政策。我们将通过隐私同意弹窗或其他符合法律要求的方式取得您的同意；敏感个人信息、系统权限、第三方账号绑定以及向LinknLink AI服务器发送个人数据，将在具体功能中另行说明并在发送前取得单独同意。对本政策的一般同意不视为您已同意发送AI相关数据。您可以拒绝非必要处理，拒绝仅会影响对应功能，不影响其他无关服务。",
          "tip": ""
        },
        {
          "title": "1. 名词定义",
          "tip": ""
        },
        {
          "title": "1.1 在本政策中，\"个人数据\"是指单独使用或结合其他信息使用时能够确定个人身份的信息。\"智能设备\"是指硬件制造商生产或制造的具有人机交互界面并通过无线网络传输数据的非标准计算设备，包括智能家用电器、智能可穿戴设备、智能空气净化器等。\"应用程序\"是指由LinknLink开发的移动应用程序，允许终端用户远程控制智能设备并连接到LinknLink的物联网（IoT）平台。",
          "tip": ""
        },
        {
          "title": "1.2 对于LinknLink支持的其他品牌的移动应用程序，是由我们的客户决定通过我们的产品收集哪些个人数据。我们根据客户要求收集信息，对这些信息的处理仅限于向客户提供约定的服务。",
          "tip": ""
        },
        {
          "title": "1.3 为了向您提供我们的服务，我们将要求您提供此类服务所必需的个人数据。如果您不提供个人数据，我们可能无法向您提供我们的产品或服务。",
          "tip": ""
        },
        {
          "title": "2. 您主动提供的信息",
          "tip": ""
        },
        {
          "title": "2.1 账户或个人资料数据：当您向我们注册账户时，我们可能收集您的姓名和联系信息，如您的电子邮件地址、电话号码、用户名和登录凭据。在您与我们产品的交互过程中，我们可能进一步收集您账户中的昵称、头像、国家代码、语言偏好或时区信息等。",
          "tip": ""
        },
        {
          "title": "2.2 反馈：当您使用我们产品中的反馈和建议功能时，我们将收集您自愿提供的电子邮件地址、手机号码和反馈内容，以便及时处理您的问题和设备故障。",
          "tip": ""
        },
        {
          "title": "2.3 设备信息：当您添加智能设备到您的账户时，我们可能收集设备的相关信息，包括设备名称、设备型号、设备ID、固件版本等。",
          "tip": ""
        },
        {
          "title": "3. 我们自动收集的信息",
          "tip": ""
        },
        {
          "title": "3.1 账户信息：您的用户昵称、头像、手机号码、电子邮件地址，以及Apple ID授权登录账户名称、Google授权登录账户名称等。",
          "tip": ""
        },
        {
          "title": "3.2 设备信息：当您与我们的产品交互时，我们会自动收集设备信息，如位置权限：当设备连接到网络时，Android 6.0或更高版本需要获取设备Wi-Fi信息（包括附近的Wi-Fi列表）、MAC地址、IP地址、无线连接信息、操作系统类型和版本、应用程序版本号、推送通知标识符、日志文件和移动网络信息。",
          "tip": ""
        },
        {
          "title": "3.3 使用数据：在您与我们网站和服务的交互过程中，我们自动收集与访问、点击、下载、发送/接收消息以及其他使用我们网站和服务相关的使用数据。",
          "tip": ""
        },
        {
          "title": "3.4 日志信息：当您使用我们的应用程序时，系统和异常日志可能会被上传。",
          "tip": ""
        },
        {
          "title": "3.5 位置信息：当您使用我们的一些产品或服务时，我们可能会收集关于您的实时精确或不精确的地理位置信息，例如天气服务。",
          "tip": ""
        },
        {
          "title": "3.6 家庭名称、家庭区域（由您手动设置）、房间信息、家庭背景图片、本地电价。",
          "tip": ""
        },
        {
          "title": "3.7 用户使用功能时通常生成的数据：场景信息、联动信息、遥控面板信息。",
          "tip": ""
        },
        {
          "title": "3.8 智能设备相关信息：",
          "tip": ""
        },
        {
          "title": "3.8.1 智能设备的基本信息：当您使用连接到我们产品或服务的智能设备时，我们可能收集有关智能设备的基本信息，如设备名称、设备ID、在线状态、激活时间、固件版本和升级信息等。",
          "tip": ""
        },
        {
          "title": "3.8.2 智能设备报告的信息：根据您选择连接到我们产品或服务的不同智能设备，我们可能收集您的智能设备报告的信息。例如，智能传感器可能报告温度和湿度、人体感应、光照等。",
          "tip": ""
        },
        {
          "title": "3.8.3 媒体文件信息：在您授权相机、相册或文件访问后，我们会在您主动拍摄、选择、裁剪、保存或分享时处理相应图片、视频、音频或文件及其文件名、大小、格式等元数据，用于头像、家庭背景、邀请二维码、固件选择、摄像头预览/截图及收据OCR。OCR主要通过设备端Google ML Kit完成；若具体页面提示需上传，我们会在取得相应授权后处理。",
          "tip": ""
        },
        {
          "title": "3.9 AI助手与语音数据：当您主动使用AI助手、语音识别、语音控制或文本转语音时，我们通过您键入、说出、选择、主动添加或授权访问的方式收集并处理文字输入、语音转写结果、会话上下文、指令、您主动添加的图片或文件以及执行结果。根据您的具体请求，还可能包括完成请求所必需且经您授权的家庭名称、房间、设备名称/标识/状态、场景与自动化、日历事件、提醒事项、联系人姓名及联系方式。麦克风仅在您主动启用语音功能并授予系统权限后使用。上述必要数据会发送至由LinknLink PTY LTD运营的LinknLink AI服务器，用于语义理解、生成回复、规划和执行您要求的智能家居或个人助理操作，以及防止滥用和保障服务安全。",
          "tip": ""
        },
        {
          "title": "3.9.1 AI数据发送同意：在首次向LinknLink AI服务器发送上述数据前，App会以单独提示明确列出发送的数据类别、接收方LinknLink PTY LTD及处理目的，并仅在您主动选择同意后发送。对本政策或用户协议的一般同意不替代该项单独同意。您可以拒绝或撤回同意；拒绝或撤回后，App不会继续向LinknLink AI服务器发送新的AI请求数据，仅需要云端AI处理的功能将不可用，其他无关功能不受影响。",
          "tip": ""
        },
        {
          "title": "3.9.2 LinknLink AI服务器由LinknLink PTY LTD运营，App不会将上述AI请求数据直接发送给第三方AI服务商。若未来需要向第三方AI服务商共享数据，我们会在发送前另行明确说明第三方名称、数据类别、用途和保护措施，确认其提供同等或更高水平的隐私保护，并重新取得您的明确同意。",
          "tip": ""
        },
        {
          "title": "3.10 系统日历、提醒事项与联系人：仅在您主动要求AI助手查询、创建、修改或删除日程/提醒，或查找联系人以发起电话、短信、邮件等操作时，经您单独授权读取或写入必要字段。Android版本还声明了短信和通话记录权限，只有相关功能实际启用、您发起指令并授权后才会访问；拒绝不影响智能家居等其他功能。",
          "tip": ""
        },
        {
          "title": "3.11 健康数据（敏感个人信息）：仅在您主动使用健康概览等功能并单独授权后，通过Apple Health或Android Health Connect读取您选择的步数、心率/静息心率、活动消耗、距离、睡眠、体重、血氧和锻炼记录及相应时间。我们不向健康平台写入或修改记录，不将健康数据用于广告，并仅为完成您的本次请求处理。",
          "tip": ""
        },
        {
          "title": "3.12 相机、相册与扫码：相机用于扫描设备二维码、拍摄收据或选择拍照来源；相册用于选择OCR图片、头像/背景图片以及保存邀请二维码或截图。拒绝后您仍可使用不依赖相机或相册的功能。",
          "tip": ""
        },
        {
          "title": "3.13 蓝牙、附近设备、Wi-Fi与本地网络：在设备配网、发现与控制时，经授权扫描并连接蓝牙设备，读取当前Wi-Fi名称/网络连接信息、附近Wi-Fi或附近设备信息，并通过mDNS、Bonjour、组播、UDP、CoAP等在局域网发现和控制设备。Android旧版本可能将Wi-Fi/蓝牙扫描归类为位置权限；我们不会据此持续追踪您的位置。",
          "tip": ""
        },
        {
          "title": "3.14 位置与地图：当您主动查询当前位置、附近地点、天气、日出日落、导航或使用地图时，经授权处理精确或大致位置及地理编码结果，并可能向Apple Maps、Google Maps或相应地理编码服务提供完成请求所需的坐标或查询词。我们不会在未说明的情况下持续后台定位。",
          "tip": ""
        },
        {
          "title": "3.15 通知与后台能力：经您授权，我们会处理推送令牌、通知内容和到达/点击状态，用于设备告警、自动化、日程提醒、AI助手及服务通知。后台音频、前台服务、开机启动、唤醒锁和忽略电池优化仅用于您启用的电台/音频播放、设备同步、通知或本地服务；您可在系统设置关闭相关权限。",
          "tip": ""
        },
        {
          "title": "3.16 设备与应用标识信息：为登录安全、设备绑定、推送、兼容性、统计和故障诊断，我们可能处理应用实例ID、内部生成的设备ID、设备型号、操作系统及版本、应用版本、语言/时区、IP地址、网络类型、Firebase安装ID、推送令牌、广告标识符（如系统提供）和崩溃日志。广告标识符仅用于应用使用统计和问题分析，不用于个性化广告；如相关处理依法构成跨App跟踪，我们会在处理前按系统和法律要求取得授权。",
          "tip": ""
        },
        {
          "title": "3.17 分享内容与已安装应用可见性：当您主动通过系统分享入口向本App发送文字、图片或文件时，我们会在本地接收并按您的指令处理。为打开您指定的第三方应用或应用商店，App可能查询有限的可处理应用/URL Scheme，不申请读取完整已安装应用列表。",
          "tip": ""
        },
        {
          "title": "3.18 红外、NFC与振动：在兼容设备上，红外权限用于遥控功能，NFC用于近场配对或读取您主动触碰的标签，振动用于操作反馈或通知；相关能力仅在您主动使用时调用。",
          "tip": ""
        },
        {
          "title": "4. 个人信息的使用",
          "tip": ""
        },
        {
          "title": "4.1 我们使用收集的个人数据用于以下目的：",
          "tip": ""
        },
        {
          "title": "4.1.1 提供、处理、维护、改善、开发我们的产品和/或提供给您的服务，包括客户支持，以及通过设备或应用程序提供的其他服务。",
          "tip": ""
        },
        {
          "title": "4.1.2 与您就有关您使用的产品和/或服务进行交流，以及就我们产品和/或服务相关的问题进行回复和反馈。",
          "tip": ""
        },
        {
          "title": "4.1.3 分析和开发与我们产品和服务的使用相关的统计数据，以更好地改进我们的产品和服务。",
          "tip": ""
        },
        {
          "title": "4.1.4 存储和维护您的信息，用于我们业务运营或履行法律义务。",
          "tip": ""
        },
        {
          "title": "4.1.5 提供个性化用户体验和个性化内容，以及产品和服务推荐。",
          "tip": ""
        },
        {
          "title": "4.1.6 通过LinknLink AI服务器理解您主动提交的请求、生成回复、规划和执行您要求的智能家居或个人助理操作，并进行必要的安全防护与故障诊断。AI请求数据不用于第三方广告或跨App跟踪。",
          "tip": ""
        },
        {
          "title": "4.2 除本政策明确说明并取得单独授权的健康数据外，我们不会主动收集有关您的种族或民族、政治观点、宗教或哲学信仰、工会成员身份、基因、生物识别、性生活或性取向等敏感信息。我们仅在特定功能所必需时处理敏感个人信息，并采取更严格的保护措施。",
          "tip": ""
        },
        {
          "title": "5. 第三方SDK接入说明",
          "tip": ""
        },
        {
          "title": "5.1 为了向您提供更好的服务，我们的应用集成了以下第三方SDK：",
          "tip": ""
        },
        {
          "title": "5.1.1 第三方账号登录及基础功能SDK：",
          "tip": ""
        },
        {
          "title": "①微信：第三方实体为深圳市腾讯计算机系统有限公司，收集信息包括一般设备信息、MAC地址、IP地址，使用目的为帮助用户通过微信登录LinknLink App，第三方隐私政策链接：https://weixin.qq.com/cgi-bin/readtemplate?lang=zh_CN&t=weixin_agreement&s=privacy",
          "tip": ""
        },
        {
          "title": "②Apple：第三方实体为Apple Inc.，收集信息包括一般设备信息、MAC地址、IP地址，使用目的为帮助用户登录Apple App，第三方隐私政策链接：https://www.apple.com/privacy/",
          "tip": ""
        },
        {
          "title": "③Google：第三方实体为Google LLC，收集信息包括一般设备信息、MAC地址、IP地址，使用目的为帮助用户通过Google账号登录LinknLink App，第三方隐私政策链接：https://policies.google.com/privacy",
          "tip": ""
        },
        {
          "title": "④Firebase Analytics、Crashlytics、Cloud Messaging：第三方实体为Google LLC，可能处理应用实例/安装标识符、广告标识符（如可用）、设备与应用信息、使用事件、IP地址、崩溃堆栈和推送令牌，分别用于使用统计、崩溃诊断和消息推送；隐私政策：https://policies.google.com/privacy",
          "tip": ""
        },
        {
          "title": "⑤Google Maps SDK：第三方实体为Google LLC，在您使用地图、位置或导航相关功能时处理坐标、地图查询及设备/网络信息；隐私政策：https://policies.google.com/privacy",
          "tip": ""
        },
        {
          "title": "⑥Google ML Kit文字识别：第三方实体为Google LLC，用于在设备端识别您主动选择或拍摄的收据/图片文字，可能处理图像内容及必要的设备信息；隐私政策：https://policies.google.com/privacy",
          "tip": ""
        },
        {
          "title": "⑦Google Sign-In与Google APIs：第三方实体为Google LLC，在您选择Google登录或授权Google Tasks等服务时处理OAuth令牌、Google账号基础信息及您授权范围内的任务数据；隐私政策：https://policies.google.com/privacy",
          "tip": ""
        },
        {
          "title": "⑧Apple Maps、Apple Health、Sign in with Apple及系统服务：第三方实体为Apple Inc.，仅在您使用相应功能并授权时，由操作系统处理Apple账号、地图请求、健康数据、日历、提醒或联系人等信息；隐私政策：https://www.apple.com/privacy/",
          "tip": ""
        },
        {
          "title": "⑨LinknLink设备SDK、ESP配网SDK及GoHap/Combined Mobile组件：由LinknLink或其技术合作方提供，用于账号、设备发现、蓝牙/Wi-Fi配网、局域网通信、设备控制、固件升级、HomeKit桥接及本地连接，可能处理账号标识、设备标识与状态、Wi-Fi/蓝牙/局域网信息、控制指令和诊断日志。",
          "tip": ""
        },
        {
          "title": "5.1.2 智能设备品牌SDK/API集成说明：",
          "tip": ""
        },
        {
          "title": "为实现不同品牌的智能设备连接与控制，我们接入了以下品牌的集成服务（包括但不限于OAuth认证、云端API、MQTT协议等）：",
          "tip": ""
        },
        {
          "title": "①涂鸦智能 (Tuya)：用于连接和控制涂鸦生态智能设备，涉及设备状态、控制指令及账号授权。",
          "tip": ""
        },
        {
          "title": "②小米米家 (Xiaomi Mi Home)：用于连接和控制小米/米家品牌设备，涉及设备信息及状态更新。",
          "tip": ""
        },
        {
          "title": "③萤石 (Ezviz)：用于海康威视/萤石品牌摄像头的视频流预览及设备控制。",
          "tip": ""
        },
        {
          "title": "④WiZ：用于局域网内WiZ品牌智能灯具的自动发现及控制。",
          "tip": ""
        },
        {
          "title": "⑤Govee：用于通过云端API或局域网控制Govee智能灯带及设备。",
          "tip": ""
        },
        {
          "title": "⑥TP-Link (Tapo/Kasa)：用于连接和控制TP-Link品牌智能插座、灯具等设备。",
          "tip": ""
        },
        {
          "title": "⑦Netatmo：用于连接和控制Netatmo品牌气象站、温控器等智能设备。",
          "tip": ""
        },
        {
          "title": "⑧HomeKit：用于实现在苹果全家桶环境下的家庭自动化及本地设备控制。",
          "tip": ""
        },
        {
          "title": "⑨Google Translate：用于应用内多语言翻译、语音合成及设备名称自动识别翻译服务。",
          "tip": ""
        },
        {
          "title": "⑩Samsung SmartThings、Amazon Alexa、Google Home：仅在您主动绑定时通过OAuth/App Flip等方式处理授权令牌、家庭/房间/设备列表、设备状态和控制指令，用于账号关联及语音/智能家居控制。",
          "tip": ""
        },
        {
          "title": "⑪Philips Hue、Dyson、Shelly、Sonoff/eWeLink、Tado、IKEA Tradfri、Nuki及其他您主动添加的品牌服务：通过品牌云API、OAuth、MQTT或局域网协议处理您授权范围内的账号令牌、设备信息、状态和控制指令。各品牌服务由相应运营者独立处理信息，具体以绑定页面及其隐私政策为准。",
          "tip": ""
        },
        {
          "title": "5.2 上述组件并非都会同时启用。我们会根据操作系统、地区、设备类型及您实际使用的功能调用相应SDK/API。第三方处理规则、服务器位置及保留期限由其隐私政策约束；您可通过不使用/解绑相应功能、撤回系统权限或联系我们来停止后续处理。",
          "tip": ""
        },
        {
          "title": "5.3 LinknLink AI服务器由LinknLink PTY LTD运营，并非第三方SDK或第三方AI服务。AI数据的收集方式、数据类别、用途、发送前同意及撤回方式见第3.9至3.9.2条。若我们委托服务商代表我们处理AI数据，我们将通过合同要求其仅按我们的指示处理，并提供与本政策相同或更高水平的隐私和安全保护。",
          "tip": ""
        },
        {
          "title": "6. 信息的共享、披露和存储",
          "tip": ""
        },
        {
          "title": "6.1 共享：我们不会向第三方出售、交易或转让您的个人数据。我们可能在以下情况下共享您的个人数据：",
          "tip": ""
        },
        {
          "title": "6.1.1 获得您的明确同意后共享。",
          "tip": ""
        },
        {
          "title": "6.1.2 在法律允许的范围内，我们可能与我们的关联公司（包括通信、社交媒体、技术和云业务）共享您的个人数据。",
          "tip": ""
        },
        {
          "title": "6.1.3 与授权合作伙伴共享：我们可能与我们的授权合作伙伴共享您的信息，以提供您要求的产品或服务，但仅限于实现该目的所需的范围内。",
          "tip": ""
        },
        {
          "title": "6.2 披露：我们可能在以下情况下披露您的个人数据：",
          "tip": ""
        },
        {
          "title": "6.2.1 根据适用的法律法规、法律程序、诉讼和/或公共机构和政府部门的要求。",
          "tip": ""
        },
        {
          "title": "6.2.2 如果我们确定披露对于执行我们的条款和条件或保护我们的运营、用户或其他人是合理必要的。",
          "tip": ""
        },
        {
          "title": "6.3 存储与跨境：我们根据您选择的国家/地区及服务可用性，使用位于中国、欧洲（包括德国）、美国等地区的服务器。仅在提供账号、设备云服务、第三方品牌绑定、AI/翻译、推送、地图或故障分析所必需且具备适用法律要求的同意、合同或其他合法基础时进行跨境传输，并采取加密、访问控制、合同约束等保护措施。",
          "tip": ""
        },
        {
          "title": "6.4 AI数据传输：当您单独同意并主动提交AI请求后，第3.9条所列的必要数据会通过加密连接传输至LinknLink AI服务器。接收方和数据控制者为LinknLink PTY LTD。除第3.9.2条所述并再次取得明确同意的情形外，我们不会将AI请求数据共享给第三方AI服务商。",
          "tip": ""
        },
        {
          "title": "7. 您的权利",
          "tip": ""
        },
        {
          "title": "7.1 根据适用的法律，您可能有权：",
          "tip": ""
        },
        {
          "title": "7.1.1 访问：您有权访问我们持有的关于您的个人数据。",
          "tip": ""
        },
        {
          "title": "7.1.2 更正：您有权更正不准确的个人数据，并更新您的信息。",
          "tip": ""
        },
        {
          "title": "7.1.3 删除：在某些情况下，您有权要求删除您的个人数据。",
          "tip": ""
        },
        {
          "title": "7.1.4 撤回同意：您有权撤回之前给予的同意。",
          "tip": ""
        },
        {
          "title": "7.1.5 反对处理：您有权反对我们处理您的个人数据。",
          "tip": ""
        },
        {
          "title": "7.1.6 数据可携带性：在某些情况下，您有权以结构化、常用和机器可读的格式接收您的个人数据。",
          "tip": ""
        },
        {
          "title": "7.2 您可以随时通过应用程序中的设置访问、更正或删除您的个人信息，或者通过我们提供的联系方式与我们联系以行使您的权利。",
          "tip": ""
        },
        {
          "title": "7.3 账户注销：您可以通过应用程序中的账户设置功能申请注销账户。账户注销后，我们将删除或匿名化处理您的个人信息，并解除账号与设备/第三方服务的关联，但法律法规另有规定或第三方依法独立保留的除外。",
          "tip": ""
        },
        {
          "title": "7.4 权限与授权管理：您可在系统设置中关闭相机、相册、麦克风、语音识别、蓝牙、附近设备、位置、通知、日历、提醒、联系人、健康等权限，也可在App内解绑Google、SmartThings、Alexa及其他品牌账号。撤回不影响撤回前基于授权已进行处理的效力。",
          "tip": ""
        },
        {
          "title": "7.5 AI授权管理：您可以在App的AI设置中撤回向LinknLink AI服务器发送数据的同意，也可以联系我们提出请求。撤回后我们将停止发送新的AI请求数据；您还可以删除AI会话记录或依照第7.1条行使访问、更正、删除等权利。",
          "tip": ""
        },
        {
          "title": "8. 数据安全",
          "tip": ""
        },
        {
          "title": "8.1 我们采取行业标准的安全措施来保护您的个人数据，包括技术措施、物理措施和管理措施，以防止个人数据丢失、滥用、未经授权的访问、披露、更改或破坏。",
          "tip": ""
        },
        {
          "title": "8.2 我们采用加密技术（如SSL）来保护数据传输过程中的安全。",
          "tip": ""
        },
        {
          "title": "8.3 我们限制访问个人数据的员工、承包商和代理，并要求他们遵守保密义务。",
          "tip": ""
        },
        {
          "title": "8.4 尽管我们已经采取了合理的安全措施，但请注意，互联网上的数据传输或存储无法保证100%的安全。",
          "tip": ""
        },
        {
          "title": "9. 数据保留",
          "tip": ""
        },
        {
          "title": "9.1 我们仅在实现本政策所述目的所必需的最短期间内保留个人数据。账号和云端设备数据通常保留至您注销账号或删除相应内容；App内AI会话记录在您删除相应记录或注销账号后删除或匿名化，发送至LinknLink AI服务器的请求和响应数据仅在提供AI服务、安全防护、故障诊断及履行法律义务所必需的期间保留，期限届满后删除或匿名化；本地缓存、OCR结果及所选文件由您清除应用数据、删除记录或卸载App时删除。第三方服务的保留期限以其隐私政策为准。",
          "tip": ""
        },
        {
          "title": "9.2 当我们的产品或服务发生停止运营的情形时，我们将采取合理的形式向您推送相关通知，并在合理的期限内删除或匿名化处理您的个人信息。",
          "tip": ""
        },
        {
          "title": "9.3 法律法规另有规定或您与我们另有约定的除外。",
          "tip": ""
        },
        {
          "title": "10. 儿童隐私",
          "tip": ""
        },
        {
          "title": "10.1 我们的产品和服务主要面向成年人。未经监护人许可，我们不会从未满16周岁的儿童那里收集个人数据。",
          "tip": ""
        },
        {
          "title": "10.2 如果我们发现自己在未事先获得监护人许可的情况下收集了儿童的个人数据，我们将设法尽快删除相关数据。",
          "tip": ""
        },
        {
          "title": "10.3 如果您是儿童的父母或监护人，当您对您所监护的儿童的个人数据处理存在疑问时，请通过本政策中的联系方式与我们联系。",
          "tip": ""
        },
        {
          "title": "11. 第三方服务",
          "tip": ""
        },
        {
          "title": "11.1 我们的产品可能包含指向第三方网站、产品和服务的链接。",
          "tip": ""
        },
        {
          "title": "11.2 我们不对第三方运营的网站、产品或服务的隐私做法负责，本政策也不适用于此类第三方网站、产品或服务。",
          "tip": ""
        },
        {
          "title": "11.3 我们建议您仔细阅读第三方的隐私政策，以了解他们如何处理您的个人信息。",
          "tip": ""
        },
        {
          "title": "12. 本政策的更新",
          "tip": ""
        },
        {
          "title": "12.1 我们可能会不时更新本政策。当我们对本政策进行重大更改时，我们会在我们的网站上发布新的隐私政策，并通过应用程序内通知或其他方式向您发送通知。",
          "tip": ""
        },
        {
          "title": "12.2 对处理目的、方式、个人信息种类、共享对象或您的权利产生重大影响的变更，我们将以显著方式提示，并在适用法律要求时重新取得您的同意。",
          "tip": ""
        },
        {
          "title": "13. 联系我们",
          "tip": ""
        },
        {
          "title": "13.1 如果您对本政策有任何疑问、意见或建议，或希望行使您的权利，您可以通过以下方式与我们联系：",
          "tip": ""
        },
        {
          "title": "公司名称：LinknLink PTY LTD",
          "tip": ""
        },
        {
          "title": "邮寄地址：7 FairyLand Ave, Chatswood West, NSW2067, Australia",
          "tip": ""
        },
        {
          "title": "电子邮件：dpo@linklink-iot.com",
          "tip": ""
        },
        {
          "title": "13.2 我们将在收到您的联系信息后尽快回复。",
          "tip": ""
        }
      ]
    }
  }
}



//////////////////
// WEBPACK FOOTER
// ./static/js/privacy.js
// module id = 2ZS2
// module chunks = 0